import { gql } from '@apollo/client'

export const SABRE_GET_BRANDS = gql`
  query GetBrands($input: BrandsInput) {
    brands(input: $input) {
      count
      hasMore
      results {
        id
        name
      }
    }
  }
`
